import type { Module } from 'vuex';
import { LanguagePageItem } from '@/types/LanguagePageItem';
import {RootState} from "@/store";

export interface LanguagePageItemsState {
  languagePageItems: LanguagePageItem[];
}

const languagePageItemsModule: Module<LanguagePageItemsState, RootState> = {
  namespaced: true,

  state: (): LanguagePageItemsState => ({
    languagePageItems: [],
  }),

  getters: {
    getById: (state) => (idLanguagePageItem: number): LanguagePageItem | undefined => {
      return state.languagePageItems.find(languagePageItem => languagePageItem.idLanguagePageItem === idLanguagePageItem);
    },
  },

  mutations: {
    setLanguagePageItems(
      state,
      payload: { languagePageItems: Record<number, any> }
    ) {
      state.languagePageItems = Object
        .values(payload.languagePageItems)
        .map(raw => LanguagePageItem.fromRaw(raw));
    },

    setLanguagePageItemCreate(
      state,
      payload: {
        idLanguagePageItem: number;
        idLanguagePage: number;
        code: string;
      }
    ) {
      const languagePageItem = new LanguagePageItem(
        payload.idLanguagePageItem,
        payload.idLanguagePage,
        payload.code,
        false,
      );
      state.languagePageItems.push(languagePageItem);
    },

    setLanguagePageItemDelete(
      state,
      payload: { idLanguagePageItem: number }
    ) {
      state.languagePageItems = state.languagePageItems.filter(
        languagePageItem => languagePageItem.idLanguagePageItem !== payload.idLanguagePageItem
      );
    },
  },

  actions: {
    wsSetLanguagePageItems({ commit }, payload) {
      commit('setLanguagePageItems', payload);
    },
    wsLanguagePageItemCreate({ commit }, payload) {
      commit('setLanguagePageItemCreate', payload);
    },
    wsLanguagePageItemDelete({ commit }, payload) {
      commit('setLanguagePageItemDelete', payload);
    },
  },
};

export default languagePageItemsModule;
